export enum ResourceType {
  Null,
  File,
  Project,
  Registration,
  RegistrationComponent,
  Preprint,
  ProjectComponent,
  Agent,
  DraftRegistration,
  Collection,
}

export enum CurrentResourceType {
  Users = 'users',
  Files = 'files',
  Projects = 'nodes',
  Registrations = 'registrations',
  Preprints = 'preprints',
  Collections = 'collections',
}
